import { render, staticRenderFns } from "./OrderAuditDetailDialog.vue?vue&type=template&id=28e80116&scoped=true&"
import script from "./OrderAuditDetailDialog.vue?vue&type=script&lang=js&"
export * from "./OrderAuditDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderAuditDetailDialog.vue?vue&type=style&index=0&id=28e80116&scoped=true&lang=less&"
import style1 from "./OrderAuditDetailDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e80116",
  null
  
)

export default component.exports